module.exports = __webpack_public_path__ + "static/img/son8_active.ed6696cc.png";